export default __webpack_public_path__ + "static/media/macapa_central.fb3ec757.jpg";